import { getColorScheme as i, listenForSchemeChange as r } from "../colorScheme.js";
import { isTest as t, isInIframe as m } from "./initConfig.js";
import { usedUikitVersion as n } from "./usedUikitVersion.js";
import { weAreHiring as s } from "./weAreHiring.js";
import { doNotUseTailwind as c } from "./doNotUseTailwind.js";
import { initCSS as f, checkCSSVersion as p } from "./initCSS.js";
import { checkForReleaseVersion as l } from "./checkForReleaseVersion.js";
import { getConsoleStyle as a } from "./styledLogs.js";
import { initPiiObserver as S } from "./initPiiObserver.js";
const F = async () => {
  if (!(!document || !document.documentElement)) {
    if (f(), !t && (S(), i(), r(), await l(), p(), !m)) {
      const o = (e) => console.log("%c%s", a(), e);
      o("- - - - - - - - - - - - - - - - - -"), n(), s(), o("- - - - - - - - - - - - - - - - - -");
    }
    await c();
  }
};
export {
  F as initDocumentBootstrapping
};
//# sourceMappingURL=initDocumentBootstrapping.js.map
